import { PlusCircleOutlined } from '@ant-design/icons'
import { Menu } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

import './ListNavigation.css'

const getSelectedKey = () => window.location.pathname.split('/').reverse()[0]

const ListNavigation = ({ match, addItemUrl, admin }) => {
  return (
    <div className="ListNavigation">
      <Menu mode="horizontal" selectedKeys={[getSelectedKey()]}>
        <Menu.Item key="championships">
          <Link to={`${match.url}/championships`}>Championships</Link>
        </Menu.Item>
        <Menu.Item key="tournaments">
          <Link to={`${match.url}/tournaments`}>Tournaments</Link>
        </Menu.Item>
        {admin && (
          <>
            <Menu.Item key="players">
              <Link to={`${match.url}/players`}>Players</Link>
            </Menu.Item>
            <Menu.Item key="categories">
              <Link to={`${match.url}/categories`}>Categories</Link>
            </Menu.Item>
            <Menu.Item key="teams">
              <Link to={`${match.url}/teams`}>Teams</Link>
            </Menu.Item>
            <Menu.Item style={{ float: 'right' }} key="add">
              <Link to={addItemUrl}>
                <PlusCircleOutlined />
                Add
              </Link>
            </Menu.Item>
          </>
        )}
      </Menu>
    </div>
  )
}

export default ListNavigation



// WEBPACK FOOTER //
// ./src/components/ListNavigation.tsx